import { addHours, formatISO, isValid } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { v4 as uuidv4 } from 'uuid';

import { roundToNearestHour } from '../../../../../utils/time';
import { DEFAULT_CUSTOM_PACING_TIMEZONE, DEFAULT_HEAVY_UP } from '../constants';
import type { CPScheduleDateRange, SetCPScheduleFormValues } from '../types';
import { CpScheduleFormFields } from '../types';

export const getFormattedCPWindowDate = (value: string): string => {
  const valueSplit = value.split(':');

  return valueSplit.length > 1 ? `${valueSplit[0]}:00` : '';
};

export const getCPWindowDateFromPreviousDate = (
  previousDate: string | null | undefined,
  amountAddedHours: number,
  fallbackTimezone: string
): string => {
  let parsedPreviousDate = previousDate ? new Date(previousDate) : null;

  if (!parsedPreviousDate || !isValid(parsedPreviousDate)) {
    parsedPreviousDate = utcToZonedTime(new Date(), fallbackTimezone);
  }

  const shiftedDate = addHours(roundToNearestHour(parsedPreviousDate), amountAddedHours);

  return getFormattedCPWindowDate(formatISO(shiftedDate));
};

export const getDefaultRange = (
  id: string,
  start: string | null = null,
  end: string | null = null
): CPScheduleDateRange => ({
  id,
  start,
  end,
  heavyUp: DEFAULT_HEAVY_UP,
});

export const getInitialValues = (): SetCPScheduleFormValues => {
  const id = uuidv4();

  return {
    [CpScheduleFormFields.Ranges]: [getDefaultRange(id)],
    [CpScheduleFormFields.Timezone]: DEFAULT_CUSTOM_PACING_TIMEZONE,
    [CpScheduleFormFields.Summary]: null,
    [CpScheduleFormFields.LineItemList]: [],
    [CpScheduleFormFields.ErrorList]: [],
    [CpScheduleFormFields.IsDynamicStartDateEnabled]: false,
    [CpScheduleFormFields.IsDynamicEndDateEnabled]: false,
  };
};
